import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from '../common/services/api/api.service';
import { GETDASHBOARDSQLDATA, GETDASHBOARDCHARTSSQLDATA, GETCATEGORYSUBCATEGORY, GETCLUSTERSITEBIGCATEGORY, GETCLUSTERBASEDONROLE, INSERTAGREEMENT, GETPIVOTTABLEDETAILS, POSTCOMPARATIVEANALYSISSTATS, POSTLOSTTREESTATS, GETPROCESSPARETOREPORTURL, GETPARETOREPORTURL } from '../common/constants/labels';
import { Observable } from 'rxjs';
import { IncidentsDashboardViewModel, IncidentsDashboardChartsViewModel, IncidentsDashboardParetoViewModel } from '../common/models/incident-dashboard-filterparameter';
import { IncidentsDashboardDataModel, PivotTableAgreement, PivotTableDataModel } from '../common/models/incident-dashboard-filterparameterdata';


@Injectable({
  providedIn: 'root'
})
export class DashboardSqlService {
  getDashboardData = environment.APISETTINGS + GETDASHBOARDSQLDATA;
  getDashboardChartsData = environment.APISETTINGS + GETDASHBOARDCHARTSSQLDATA;
  getCategoryandSubCategoryURL = environment.DFOSBASEURL + GETCATEGORYSUBCATEGORY;
  getClusterAndFactoryURL = environment.APISETTINGS + GETCLUSTERSITEBIGCATEGORY;
  getClusterDFOSURL = environment.DFOSBASEURL + GETCLUSTERBASEDONROLE;
  insertAgreement = environment.APISETTINGS + INSERTAGREEMENT;
  getPivotTable = environment.APISETTINGS + GETPIVOTTABLEDETAILS;
  getLostTreeStats = environment.APISETTINGS + POSTLOSTTREESTATS;
  getComparativeAnaysisData = environment.APISETTINGS + POSTCOMPARATIVEANALYSISSTATS;
  getProcessParetoReportURL = environment.APISETTINGS + GETPROCESSPARETOREPORTURL;
  getParetoReportURL = environment.APISETTINGS + GETPARETOREPORTURL;
  cluster: string;
  site: string;
  bigcategory: string;

  constructor(private service: ApiService) { }

  public setCluster(value: string) {
    this.cluster = value;
  }
  public getCluster() {
    return this.cluster;
  }
  public setSite(value: string) {
    this.site = value;
  }
  public getSite() {
    return this.site;
  }
  public setBigCategory(value: string) {
    this.bigcategory = value;
  }
  public getBigCategory() {
    return this.bigcategory;
  }

  public getDashboardReportData(filterParameter: IncidentsDashboardViewModel): Observable<IncidentsDashboardDataModel> {
     return this.service.post(this.getDashboardData, filterParameter);
  }

  public getDashboardChartsReportData(filterParameter: IncidentsDashboardChartsViewModel): Observable<IncidentsDashboardDataModel> {
    return this.service.post(this.getDashboardChartsData, filterParameter);
 }

  public getPivotTableData(filterParameter: IncidentsDashboardViewModel): Observable<PivotTableDataModel> {
    return this.service.post(this.getPivotTable, filterParameter);
 }

 public getProcessParetoReportData(filterParameter: IncidentsDashboardParetoViewModel): Observable<any> {
  return this.service.post(this.getProcessParetoReportURL, filterParameter);
 }

 public getParetoReportData(filterParameter: IncidentsDashboardParetoViewModel): Observable<any> {
   return this.service.post(this.getParetoReportURL, filterParameter);
 }

  public insertAgreementDetails(pivotData: PivotTableAgreement): Observable<any> {
    return this.service.post(this.insertAgreement, pivotData);
 }

  public getDashboardFilterData(): Observable<any> {
    return this.service.get(this.getCategoryandSubCategoryURL);
 }

 public getClusterFactoryData(): Observable<any> {
  return this.service.get(this.getClusterAndFactoryURL);
}

public getClusterFromDFOS(role: string): Observable<any> {
  return this.service.get(this.getClusterDFOSURL + '?role=' + role + '&decomissioned=false');
}

public getLostTreeStatsData(filterParameter): Observable<any> {
  return this.service.post(this.getLostTreeStats, filterParameter);
}

public getComparativeAnalysisData(filterParameter): Observable<any> {
  return this.service.post(this.getComparativeAnaysisData, filterParameter);
  }
}
